
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import {Prop} from 'vue-property-decorator';
    import {
        MinimalDocumentModel
    } from "@/api-client";
    import DocumentValidity from "@/features/documents/query/components/DocumentValidity.vue";
    import DocumentValidityQueryTimestamp from "@/features/shared/components/DocumentValidityQueryTimestamp.vue";
    
    @Component({
        components: {
            DocumentValidity,
            SectionPageHeading,
            DocumentValidityQueryTimestamp
        }
    })
    export default class MinimalDocumentDetails extends Vue {
        @Prop({required: true})
        details!: MinimalDocumentModel;
    }
